import React from "react";

import GeneralSettings from "./components/GeneralSettings/GeneralSettings";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import { MfaSettings } from "./components";

import { Stack } from "@components/base";

const AccountGeneralSettings: React.FC = () => (
  <Stack spacing={2}>
    <GeneralSettings />
    <ResetPassword />
    <MfaSettings />
  </Stack>
);

export default AccountGeneralSettings;
